<div #gridPage class="leads-grid-host" [class.in-dialog]="dialogData?.isOpenedFromDashboard"
  [style.height.px]="dialogData?.isOpenedFromDashboard ? null : gridPageHeight()">
  @if (dialogData?.isOpenedFromDashboard) {
    <div class="header">
      <div class="d-flex w-100 py-3 px-4">
        <div class="me-2 id flex-fill">
          <h4 class="modal-title mb-0 item-id">
            Leads - {{ dialogData?.filteredStatus }}
          </h4>
        </div>
        <div class="btns-header">
          <button class="close" (click)="dialogRef.close()" aria-label="Close">
            <i class="fas fa-times" title="Close Popup"></i>
          </button>
        </div>
      </div>
    </div>
  }
  @if (showLoader()) {
    <app-loader></app-loader>
  }
  <div class="leads-grid">
    @if (gridConfig(); as config) {
      <inavista-grid #leadsGrid
        [config]="config"
        [actionIcons]="actionIcons()"
        (actionIconClick)="onActionIconClick($event)"
        (hyperlinkClick)="onHyperlinkClick($event)"
        (toolbarActionClick)="onToolbarActionClick($event)"
        (exportRequested)="onExportRequested($event)" />
    }
  </div>
</div>

<!-- Business Partner: a link to the business partner when the lead has one, as before. -->
<ng-template #businessPartnerCell let-row>
  @if (row?.soldToExtId) {
    <a href="javascript:" (click)="onBPIdClick(row.soldToExtId)">{{ row?.soldToBPName }}</a>
  } @else {
    {{ row?.soldToBPName }}
  }
</ng-template>
